import type { MediaFolderResponse } from '@/core/generated/api';

/** Форматирует число файлов с русским окончанием */
export const formatMediaFileCount = (count: number): string => {
    const form = new Intl.PluralRules('ru-RU').select(count);

    return `${count} ${form === 'one'
        ? 'файл'
        : form === 'few'
            ? 'файла'
            : 'файлов'}`;
};

/** Возвращает краткое название формата изображения */
export const formatMediaType = (contentType?: string | null): string => contentType === 'image/svg+xml'
    ? 'SVG'
    : contentType?.split('/')[1]?.toUpperCase() ?? 'Изображение';

/** Форматирует известное разрешение изображения */
export const formatMediaDimensions = (width?: number | null, height?: number | null): string => width && height && width > 0 && height > 0
    ? `${width} × ${height} px`
    : 'Размеры неизвестны';

/** Форматирует объём изображения */
export const formatMediaSize = (bytes?: number | null): string => {
    if (bytes == null) return 'Размер неизвестен';

    return bytes >= 1024 * 1024
        ? `${(bytes / 1024 / 1024).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} МБ`
        : `${Math.ceil(bytes / 1024).toLocaleString('ru-RU')} КБ`;
};

/** Возвращает путь логической папки с защитой от циклов */
export const getMediaFolderPath = (folders: MediaFolderResponse[], id?: string | null): string => {
    const names: string[] = [];
    const visited = new Set<string>();
    let current = id;

    while (current && !visited.has(current)) {
        visited.add(current);
        const folder = folders.find(item => item.id === current);

        if (!folder) break;

        names.unshift(folder.name ?? 'Папка');
        current = folder.parentId;
    }

    return ['Все файлы', ...names].join(' / ');
};

/** Сохраняет загруженный архив через временную ссылку */
export const saveMediaDownload = (content: Blob): void => {
    const url = URL.createObjectURL(content);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'vox-media.zip';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
